function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { PhotoIcon } from '@domain-group/fe-co-icon';
import MultiResolutionImage from '@domain-group/fe-co-multi-resolution-image';
import { AllImageSizes, getImageUrl } from '@domain-group/fe-allhomes-library/lib/enums/image-size';
import * as styles from './images.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Images = _ref => {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$firstImage = _ref.firstImage,
    firstImage = _ref$firstImage === void 0 ? null : _ref$firstImage,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    layout = _ref.layout,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? null : _ref$href,
    _ref$anchorAttributes = _ref.anchorAttributes,
    anchorAttributes = _ref$anchorAttributes === void 0 ? {} : _ref$anchorAttributes,
    logo = _ref.logo,
    alt = _ref.alt;
  var hasDevelopmentLogo = Boolean(logo.url);
  var imgClass = styles.imageUnderlay({
    hasDevelopmentLogo,
    layout
  });
  return ___EmotionJSX("a", _extends({
    css: styles.image({
      layout
    }),
    href: href !== null && href !== void 0 ? href : undefined,
    onClick: evt => {
      evt.stopPropagation();
    }
  }, anchorAttributes), (logo === null || logo === void 0 ? void 0 : logo.url) && ___EmotionJSX("span", {
    css: styles.logo(logo)
  }, ___EmotionJSX("img", {
    css: styles.logoImage,
    src: logo === null || logo === void 0 ? void 0 : logo.url,
    alt: logo === null || logo === void 0 ? void 0 : logo.name
  })), ___EmotionJSX("span", {
    css: styles.imageContainer
  }, firstImage ? ___EmotionJSX(MultiResolutionImage, {
    css: imgClass,
    src: getImageUrl(firstImage, AllImageSizes.LARGE),
    alt: alt
  }) : ___EmotionJSX("span", {
    css: imgClass
  }, ___EmotionJSX("span", {
    css: styles.missingImage
  }, ___EmotionJSX("span", null, ___EmotionJSX(PhotoIcon, {
    size: "regular"
  })), ___EmotionJSX("span", {
    className: "".concat(className, "-img-text")
  }, "Image not available"))), ___EmotionJSX("span", {
    css: styles.contents
  }, children)));
};